import { Flex, Text } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { v4 as uuidv4 } from "uuid";

import { StyledTh } from "../../../styled";
import VitalsTimeline from "../../_Medical/Vitals/VitalsTimeline/VitalsTimeline";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { toggleSectionCollapse } from "../../../redux/slices/generatorSlice";
import { setEditing } from "../../../redux/slices/entrySlice";

interface Props {
  title: any;
  subtitle: any;
  center: any;
  showVitals: boolean | undefined;
  sectionIndex: number;
  collapseable?: boolean;
  collapsed?: boolean;
}
const PortraitSectionTitle = ({
  title,
  subtitle,
  showVitals,
  sectionIndex,
  center,
  collapseable,
  collapsed,
}: Props) => {
  const dispatch = useDispatch();

  const handleToggleCollapse = () => {
    if (collapseable) {
      dispatch(toggleSectionCollapse({ sectionIndex }));
      dispatch(setEditing(true));
    }
  };

  if (!title && !subtitle) {
    return <></>;
  }
  return (
    <thead>
      <tr>
        <StyledTh
          align="left"
          colSpan={100}
          key={uuidv4()}
          style={{
            cursor: collapseable ? "pointer" : "default",
          }}
          onClick={handleToggleCollapse}>
          <Flex
            py={5}
            px={10}
            gap={5}
            justify={center ? "center" : "space-between"}
            align="center">
            <Flex direction="column" gap={5}>
              {title && (
                <Text
                  c="inherit"
                  inherit
                  size="sm"
                  ta={center ? "center" : "left"}>
                  {title}
                </Text>
              )}
              {subtitle && (
                <Text c="inherit" inherit size="xs">
                  {subtitle}
                </Text>
              )}
            </Flex>
            <Flex align="center" gap={10}>
              {/*Do not remove!!!!!*/}
              {/*{showVitals && <VitalsTimeline sectionIndex={sectionIndex} />}*/}
              {collapseable && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {collapsed ? (
                    <IconChevronDown size={20} />
                  ) : (
                    <IconChevronUp size={20} />
                  )}
                </div>
              )}
            </Flex>
          </Flex>
        </StyledTh>
      </tr>
    </thead>
  );
};
export default PortraitSectionTitle;
